//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect, useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
  Paper,
  Typography,
} from '@mui/material';

import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';

// === COMPONENTS ===
import { TaskModal } from '../TaskModal/TaskModal';
import { removeStatsScheduleTask } from 'api/prokey/prokey.websocket';
import { SchedulerContext } from '../SchedulerContext/SchedulerContext';

//#endregion

//-----------------------------------------------------------------
export function ControlBox() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const theme = useTheme();

  const { selected } = useContext( SchedulerContext );

  const [ is_open_modal  , setIsOpenModal  ] = useState( false );
  const [ is_open_filter , setIsOpenFilter ] = useState( false );

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      padding: '0.5rem',
      display: 'flex',
      marginBottom: '0.5rem',
    },
    container_buttons: {
      marginLeft : 'auto'  ,
    },
    button_delete: {
      height     : '4rem'  ,
      width      : '10rem' ,
    },
    button_schedule: {
      marginLeft : '1rem'  ,
      height     : '4rem'  ,
      width      : '14rem' ,
    },
  }

  // === ATTRIBUTES ===
  const
    CONTAINER = {
      sx: _styles.container,
    },
    CONTAINER_BUTTONS = {
      sx: _styles.container_buttons,
    },
    BUTTON_TASK_DELETE = {
      sx       : _styles.button_delete ,
      variant  : 'contained'           ,
      color    : 'error'               ,
      disabled : !selected             ,
      onClick  : handleDelete          ,
      children : [ 'Delete' ]          ,
      name     : 'delete_report_scheduler_task_btn',
    },
    BUTTON_SCHEDULE_TASK = {
      sx       : _styles.button_schedule ,
      variant  : 'contained'           ,
      color    : 'primary'             ,
      endIcon  : <ScheduleSendIcon />  ,
      onClick  : handleModalOpen       ,
      children : ['Create Task']       ,
      name     : 'create_report_scheduler_task_btn',
    };

  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function handleModalOpen(event) {
    //-----------------------------------------------------------------
    setIsOpenModal( true );
  };

  //-----------------------------------------------------------------
  function onModalClose(event) {
    //-----------------------------------------------------------------
    try {
      setIsOpenModal(false)
    } catch (error) {
      console.warn(error);
    }
  }
  
  //-----------------------------------------------------------------
  function handleDelete(event) {
    //-----------------------------------------------------------------
    removeStatsScheduleTask( selected );
  };

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box { ...CONTAINER }>        
        <TaskModal is_open={is_open_modal} onClose={onModalClose} />
        <Typography variant='h4' color='primary'>Report Scheduler</Typography>
        <Box { ...CONTAINER_BUTTONS }>
          <Button { ...BUTTON_TASK_DELETE } />
          <Button { ...BUTTON_SCHEDULE_TASK } />
        </Box>
      </Box>
    );
  };

  //#endregion

  return display();
}